import React, { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { gameProgressState } from '../state';
import styled from 'styled-components';

const StyledShareButton = styled.div`
display: flex;
margin: 20px 10px;
justify-content: center;
@media only screen and (max-width: 600px) {
}
`
const ShareButton = styled.img`
max-height: 50px;
padding:3px;
@media only screen and (max-width: 600px) {
  max-width:92%;
}
`

const Intro = () => {
  const setGameProgress = useSetRecoilState(gameProgressState);
  const [section, setSection] = useState(0);

  let sectionComp = null;
  if (section === 0) {
    sectionComp = (
      <>
        <img src="img/hrtlogo.png" className="hrt-logo-intro" alt='hrt-logo' />
        <div className="introduction">
          <p>石虎在其他國家活得好好的<br />
            在臺灣卻逐漸消失<br />
            <br />
            生活環境危機四伏<br />
            棲地破碎化<br />
            過馬路被撞死<br />
            捕獸鋏地雷<br />
            流浪貓犬攻擊……<br />
            石虎每天都得面對生存考驗<br />
            <br />
            你能幫助飢腸轆轆的石虎<br />
            避開威脅並順利填飽肚子嗎？<br />
            <br />
          </p>
          <button onClick={() => setSection(1)} className='intro-button'>玩法說明</button>
          <button onClick={() => setGameProgress('main')} className='intro-button'>SKIP / 跳過 >></button>
          <StyledShareButton>
            <a href="https://www.facebook.com/2016homeruntaiwan" target="_blank"><ShareButton src={'img/share_fb.png'} /></a>
            <a href="https://www.instagram.com/homerun.taiwan/" target="_blank"><ShareButton src={'img/share_ig.png'} /></a>
          </StyledShareButton>
        </div>

      </>
    );
  } else {
    sectionComp = (
      <>
        <img src="img/hrtlogo.png" className="hrt-logo-intro" alt='hrt-logo' />
        <div className="introduction">
          <p>可向左右滑動，或按左右鍵<br />
            控制石虎移動<br />
            以避開障礙物或取得食物<br />
            <br />
            每碰到障礙物扣一滴血<br />
            三滴血都扣完遊戲結束<br />
            <br />
            隨著時間倒數<br />
            前進速度越快<br />
            障礙物出現數量也越多<br />
            <br />
          </p>
          <button onClick={() => setGameProgress('main')} className='intro-button'>START / 開始</button>
          <StyledShareButton>
            <a href="https://www.facebook.com/2016homeruntaiwan" target="_blank"><ShareButton src={'img/share_fb.png'} /></a>
            <a href="https://www.instagram.com/homerun.taiwan/" target="_blank"><ShareButton src={'img/share_ig.png'} /></a>
          </StyledShareButton>
        </div>

      </>
    );
  }

  return (
    <div>
      <div className="start-frame">
        <div className="start-title">
          {sectionComp}
        </div>
      </div>
    </div>
  );
};

export {
  Intro
};
